import React from 'react';
import { agregarformatoPesos, formatRut, ocultarDatosTarjeta } from '../../../utils/formatters';
import Detalle from './styles';
import Skeleton from 'react-loading-skeleton';


const Comprobante = ({ setData }) => {
  const loadInfo = Object.keys(setData).length;
  const { medioPago, numeroTarjeta, saldoDisponible, monto } = setData;
  
  const MedioDepago = ({medio,saldo,nTarjeta,cargando}) =>{
    const tipoDePago = medio === "01" ? 'Tarjeta de Crédito:' :'Saldo disponible:';
    const medioPago = medio === "01"? ocultarDatosTarjeta(nTarjeta) : agregarformatoPesos(saldo);
    return (
      <>
      <div className="row-detalle">
        
        <span>{cargando === 0? <Skeleton width={100} height={20} /> : tipoDePago}</span>
        <p>{cargando === 0? <Skeleton width={100} height={20} /> : medioPago }</p>
      </div>
      </>
    )
  }

  return (
    <Detalle>
      <div className="row-detalle">
        <span>{ loadInfo === 0 ? <Skeleton width={50} height={20} />  : 'Fecha' }</span>
        <p className="nombre-socio">{ loadInfo === 0 ? <Skeleton width={100} height={20} /> : setData.fechaTrx }</p>
      </div>
      <div className="row-detalle separador-comprobante">
        <span>{loadInfo === 0 ? <Skeleton width={90} height={20} /> :'Comercio'}</span>
        <p>{ loadInfo === 0 ? <Skeleton width={90} height={20} />  : setData.comercio}</p>
      </div>
      <div className="row-detalle">
        <span className="strong">
        { loadInfo === 0 ? <Skeleton width={30} height={20} />:'Monto'}
        </span>
        <p>
          <strong>{ loadInfo === 0 ? <Skeleton width={30} height={20} /> : agregarformatoPesos(setData.monto)}</strong>
        </p>
      </div>
      <MedioDepago 
        medio={medioPago}
        saldo={saldoDisponible}
        nTarjeta={numeroTarjeta}
        cargando={loadInfo}
      />
      <div className="row-detalle">
        <span>{ loadInfo === 0 ? <Skeleton width={70} height={20} />  : 'RUT'}</span>
        <p>{ loadInfo === 0 ? <Skeleton width={70} height={20} />  : formatRut(setData.rut)}</p>
      </div>
    </Detalle>
  );
};

export default Comprobante;
